<div class="deepseek-dialog">
  <button
    class="close-btn"
    mat-icon-button
    (click)="close()"
    aria-label="Close Deepseek R1 Info"
  >
    ×
  </button>

  <div class="header">
    <img src="assets/logos/deepseek.svg" alt="Deepseek R1 Logo" class="mini-logo" />
    <h2>Deepseek&nbsp;R1</h2>
    <div class="sub">Reasoning-first model tuned for technical precision, code workflows, and structured problem solving</div>
  </div>

  <div class="body">
    <p>
      <strong>Deepseek&nbsp;R1</strong> is designed for users who value <strong>correctness</strong>, <strong>clarity</strong>, and
      <strong>implementation-ready</strong> answers. Compared to more “chatty” assistants, R1 tends to focus on
      structured breakdowns, explicit assumptions, and step-by-step logic—making it especially useful for
      <strong>software engineering</strong>, <strong>math</strong>, and <strong>systems thinking</strong>.
    </p>

    <ul>
      <li>⚡ <strong>Fast, technical throughput:</strong> optimized for crisp solutions and predictable formatting in code-heavy tasks.</li>
      <li>🧠 <strong>Reasoning-oriented:</strong> breaks complex prompts into smaller steps, keeping logic consistent and traceable.</li>
      <li>🧩 <strong>Strong debugging mindset:</strong> good at isolating root causes, proposing hypotheses, and suggesting targeted checks.</li>
      <li>📐 <strong>Math + logic friendly:</strong> comfortable with derivations, constraints, and algorithmic reasoning.</li>
      <li>🧾 <strong>Structured communication:</strong> produces checklists, procedures, and technical writeups that are easy to follow.</li>
    </ul>

    <div class="optimal">
      <h3>Best use cases</h3>
      <ul>
        <li><strong>Production code work:</strong> refactors, bug fixes, tests, performance improvements, and reviews</li>
        <li><strong>Algorithms + data structures:</strong> explanations, walkthroughs, complexity analysis, and implementations</li>
        <li><strong>Engineering problem solving:</strong> design tradeoffs, incident analysis, and system reasoning</li>
        <li><strong>Technical documentation:</strong> specs, runbooks, READMEs, API docs, and “how it works” guides</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>How to get the best results</h3>
      <ul>
        <li><strong>Paste the real artifacts:</strong> error logs, stack traces, configs, snippets, or failing inputs.</li>
        <li><strong>State constraints:</strong> language/framework version, performance goals, and any “must/must not” rules.</li>
        <li><strong>Ask for rigor:</strong> request edge cases, complexity, and a quick validation plan.</li>
        <li><strong>Specify output shape:</strong> “Return a patch”, “Return JSON”, “Return a checklist”, etc.</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>Tip</h3>
      <ul>
        <li>
          Deepseek R1 shines in <strong>structured technical workflows</strong>. If you’re doing creative writing,
          brand voice, or highly conversational interaction, a more dialogue-styled model may feel smoother.
        </li>
      </ul>
    </div>
  </div>
</div>
